module.exports = __webpack_public_path__ + "img/31.86f62c9c.jpg";